module.exports = __webpack_public_path__ + "static/img/card_4_12.cb783d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_4_12.png
// module id = rW8l
// module chunks = 0